import React from 'react';
import { logoImg } from '../utils/theme';
import { SOCIAL_LOGIN_LAYOUTS } from './SocialLogin';
import { registerClass, classNames } from '@food/css-manager';
var logoDimension = registerClass(function () { return "\n\twidth: 90%;\n\tmax-height: 20vmax;\n"; });
var style = registerClass(function () { return "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n"; });
export var Logo = function (_a) {
    var custom = _a.custom, layout = _a.layout;
    return (React.createElement("div", { className: classNames(style, !custom && 'logo') }, custom && (React.createElement("img", { src: custom, alt: 'Food auth', className: classNames(logoImg, layout === SOCIAL_LOGIN_LAYOUTS.STANDARD && logoDimension) }))));
};
//# sourceMappingURL=Logo.js.map